import React from "react";

import { FormatCurrencyOptions, formatNumericCurrency } from "utils";

import { CurrencyCode } from "consts";

import { Icon } from "components";

type Color = "blue" | "grey" | "red" | "orange" | "green" | "";

type PaymentRangeProps = {
  min: number;
  max: number;
  currency: CurrencyCode;
  minColor?: Color;
  maxColor?: Color;
  size?: "large" | "medium" | "small" | "x-small";
  className?: string;
  innerClassName?: string;
};

export const PaymentRange = ({ min, max, currency, minColor = "", maxColor = "", size = "medium", className = "", innerClassName = "" }: PaymentRangeProps) => {
  const minDetails = { payment: min, color: minColor };
  const maxDetails = { payment: max, color: maxColor };
  const minimum = min < max ? minDetails : maxDetails;
  const maximum = min < max ? maxDetails : minDetails;

  const currencyOpts: FormatCurrencyOptions = { currency, decimals: 0, signDisplay: "exceptZero" };

  if (minimum.payment === maximum.payment) {
    return (
      <p className={`payment-range ${className}`}>
        <span className={`${maximum.color} ${size} ${innerClassName}`}>{formatNumericCurrency(maximum.payment, currencyOpts)}</span>
      </p>
    );
  }

  return (
    <p className={`payment-range ${className}`}>
      <span className={`${minimum.color} ${size} ${innerClassName}`}>{formatNumericCurrency(minimum.payment, currencyOpts)}</span>
      <Icon iconName="klim/minus" className={"icon inline"} size={size === "large" ? "m" : "s"} />
      <span className={`${maximum.color} ${size} ${innerClassName}`}>{formatNumericCurrency(maximum.payment, currencyOpts)}</span>
    </p>
  );
};
